import axios from "../utils/axios";
import {
  PATIENT_FIELD_RETRIEVED,
  PRESCRIPTION_FIELD_RETRIEVED,
  FREE_SHIPPING_SETTINGS_RECEIVED,
  SCHOOL_RETRIEVED,
  PICKUP_ADDRESS_RECEIVED,
  REMEMBER_SETTINGS_RECEIVED,
} from "../constants/types/settingsType";
import { ERROR, SUCCESS } from "../constants/types/alertType";
import { appLoading } from "./alertAction";

export const getPatientFormSettings = (callback) => (dispatch) => {
  axios.get("manageForms?action=getPatientFormSettings").then(
    (resp) => {
      if (resp?.data?.result == "success") {
        dispatch({
          type: PATIENT_FIELD_RETRIEVED,
          payload: resp.data.fields,
        });
        callback && callback();
      } else {
        dispatch({
          type: ERROR,
          payload: "Failed to get fields",
        });
        callback && callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get fields",
      });
      callback && callback();
    }
  );
};

export const getPrescriptionFormSettings = (callback) => (dispatch) => {
  axios.get("manageForms?action=getPrescriptionFormSettings").then(
    (resp) => {
      if (resp?.data?.result == "success") {
        dispatch({
          type: PRESCRIPTION_FIELD_RETRIEVED,
          payload: resp.data.fields,
        });
        callback &&
          callback(
            resp.data.fields.preparationMethods,
            resp.data.fields.maximumGramForCreation
          );
      } else {
        dispatch({
          type: ERROR,
          payload: "Failed to get fields",
        });
        callback && callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get fields",
      });
      callback && callback();
    }
  );
};

export const getFreeShippingSettings = (callback) => (dispatch) => {
  axios.get("manageForms?action=getFreeShippingSettings").then(
    (resp) => {
      if (resp?.data?.result == "success") {
        dispatch({
          type: FREE_SHIPPING_SETTINGS_RECEIVED,
          payload: resp.data.fields,
        });
        callback && callback();
      } else {
        dispatch({
          type: ERROR,
          payload: "Failed to get fields",
        });
        callback && callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get fields",
      });
      callback && callback();
    }
  );
};

export const getRememberSettings = (callback) => (dispatch) => {
  axios.get("manageForms?action=getRememberSettings").then(
    (resp) => {
      if (resp?.data?.result == "success") {
        dispatch({
          type: REMEMBER_SETTINGS_RECEIVED,
          payload: resp.data.fields,
        });
        callback && callback();
      } else {
        dispatch({
          type: ERROR,
          payload: "Failed to get fields",
        });
        callback && callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get fields",
      });
      callback && callback();
    }
  );
};

export const formPostAction = (data, callback) => (dispatch) => {
  axios.post(`manageForms`, data).then(
    (resp) => {
      if (resp.data?.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.console.error(),
        });
        callback();
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to get fields",
      });
      callback();
    }
  );
};

export const getschoolList = (callback) => (dispatch) => {
  axios.get("manageForms?action=getSchoolList").then(
    (resp) => {
      if (resp?.data?.result == "success") {
        dispatch({
          type: SCHOOL_RETRIEVED,
          payload: resp.data.fields,
        });
        callback && callback(resp.data.fields.preparationMethods);
      } else {
        dispatch({
          type: ERROR,
          payload: "Failed to get fields",
        });
        callback && callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get fields",
      });
      callback && callback();
    }
  );
};
export const settingsPostAction = (data, callback) => (dispatch) => {
  dispatch(appLoading(true));
  axios.post("manageForms", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
        dispatch(appLoading(false));
      } else {
        callback && callback();
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        dispatch(appLoading(false));
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      dispatch(appLoading(false));
    }
  );
};
